'use strict';

var validateHistoryGraphBisModalCtrl = ['$state', '$scope', '$uibModal', 'Form', function ($state, $scope, $uibModal, Form) {
    var _this = this;
    // console.log('validateHistoryGraphBisModal $scope', $scope)
    
    try {
        _this.parsedField = JSON.parse(_this.field);
    } catch (error) {
        console.log(error);
    }

    _this.viewList = () => {
        $uibModal.open({
            animation: true,
            templateUrl: 'gridGraph-directive/validateHistoryGraphBisModal.html',
            controller: ["$uibModalInstance", 'dataValidations',
                function ($uibModalInstance, dataValidations) {
                    this.dataValidations = dataValidations;

                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                }],
            controllerAs: 'modal',
            size: 'xlg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                dataValidations: function () {
                    const validations = _this.data?.[_this.parsedField.name];
                    if (!Array.isArray(validations)) {
                        return [];
                    }
                    return validations
                        .filter(v => v && typeof v === 'object')
                        .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : a.updatedAt > b.updatedAt ? -1 : 0))
                        .map(validation => ({
                            ...validation,
                            updatedAtFormatted: validation.updatedAt ? new Date(validation.updatedAt).getYYYYMMddHHmmss() : "",
                            canceledAtFormatted: validation.canceledAt ? new Date(validation.canceledAt).getYYYYMMddHHmmss() : "",
                        }));
                },

            },
        }).result.then((result) => {
        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '@',
            data: '='
        },
        controller: validateHistoryGraphBisModalCtrl,
        controllerAs: 'modal',
        bindToController: true,
        // template: '<a ng-if="modal.data[modal.parsedField.name].length>0" ng-click="modal.viewList(); $event.stopPropagation()">{{modal.data[modal.parsedField.name].length}} registros 2 <i class="glyphicon glyphicon-list-alt"></i><i class="glyphicon glyphicon-book"></i><i class="glyphicon glyphicon-file"></i><i class="glyphicon glyphicon-education"></i><i class="glyphicon glyphicon-info-sign"></i></a>'
        template: '<a ng-if="modal.data[modal.parsedField.name].length>0" ng-click="modal.viewList(); $event.stopPropagation()">{{modal.data[modal.parsedField.name].length}} <i class="glyphicon glyphicon-file"></i></a>'
    };
};
